import type { AgentModelEndpoint } from '@reflex/shared';

/**
 * Whether a user-supplied API key can satisfy an endpoint that the server
 * reported as unavailable. The launcher injects the picked key as the
 * endpoint's secret-backed credential (`agent-runner.service` →
 * `pinnedApiKey`), so an endpoint blocked only on `fromSecret` env vars (or on
 * an unknown org-key status) becomes launchable. A `matrix_unavailable`
 * endpoint, or one missing a non-secret required var (e.g. a base URL), is
 * not satisfiable by a key alone.
 */
export function isEndpointSatisfiableByProviderKey(endpoint: AgentModelEndpoint): boolean {
  const { available, reasons, missingEnvVars } = endpoint.availability;
  if (available) return true;
  if (reasons.includes('matrix_unavailable')) return false;
  const secretBackedNames = new Set(
    endpoint.envVars.filter((v) => v.fromSecret).map((v) => v.name),
  );
  return missingEnvVars.every((name) => secretBackedNames.has(name));
}
